module.exports = __webpack_public_path__ + "img/lane-below.890c069b.svg";